/* RESPONSIBLE TEAM: team-actions */

import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class IndexController extends Controller {
  queryParams = ['title', 'state', 'sort', 'sortDir', 'tags'];

  @tracked title: string | null = null;
  @tracked state: string | null = null;
  @tracked sort: string | null = null;
  @tracked sortDir: string | null = null;
  @tracked tags: string | null = null;
}
